import { useCallback, useEffect, useRef } from 'react';

import { useObserver } from '@/lib/shared/hooks/use-observer';

import { useFixedFilter } from '../ui/catalog-fixed-filter-provider';

export const useSetFixedFilter = () => {
  const filterRef = useRef<HTMLDivElement>(null);
  const { setIsFixed, isFixed } = useFixedFilter();

  const setFixed = useCallback(() => {
    setIsFixed(true);
  }, [setIsFixed]);
  const unsetFixed = useCallback(() => {
    setIsFixed(false);
  }, [setIsFixed]);

  useObserver({
    ref: filterRef,
    isInterTrue: unsetFixed,
    isInterFalse: setFixed,
  });

  useEffect(() => {
    return () => {
      if (!isFixed) {
        setIsFixed(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIsFixed]);
  return filterRef;
};
